<div class="fullscreen-carousel-images-wrapper">
    <app-images-slider [slides]="slides"></app-images-slider>
</div>

